// src/pages/ForgotPassword.js — public. Sends a reset email through the
// backend (POST /api/auth/password-reset), whose link lands on /set-password.
// The response is the same whether or not the email has an account.
import { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../lib/api'
import AuthShell from '../components/AuthShell'

export default function ForgotPassword() {
  const [email, setEmail]           = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sentMessage, setSent]      = useState(null)
  const [error, setError]           = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      const { data } = await api.post('/api/auth/password-reset', { email: email.trim() })
      setSent(data.data?.message || "If an account exists for that email, we've sent a reset link.")
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send you a link to choose a new password.">
      {sentMessage ? (
        <div role="status" style={{ fontSize: 13, color: 'var(--text-primary)', lineHeight: 1.5 }}>
          {sentMessage} The link expires after a short time, so use it soon.
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {error && (
            <div role="alert" style={{
              background: 'var(--danger-muted)', border: '1px solid rgba(239,68,68,0.25)',
              borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 13, color: 'var(--danger-text)',
            }}>{error}</div>
          )}
          <div className="input-group">
            <label className="input-label" htmlFor="reset-email">Email</label>
            <input id="reset-email" className="input" type="email" autoComplete="email" required autoFocus
              value={email} onChange={e => setEmail(e.target.value)} placeholder="you@rgagroup.net" />
          </div>
          <button type="submit" className="btn btn-primary" disabled={submitting} style={{ width: '100%', padding: '10px' }}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <Link to="/login" style={{ fontSize: 12, color: 'var(--accent)' }}>Back to sign in</Link>
    </AuthShell>
  )
}
